<template>
  <div id="app">
    <!--
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> | 
      <router-link to="/carousel">Carousel</router-link>
    </div>
    -->
    <transition name="slide">
      <router-view />
    </transition>
  </div>
</template>
<script>
const ONE_HOUR_IN_MS = 60 * 60 * 1000;
const RELOAD_CACHE_AFTER_MS = 6 * ONE_HOUR_IN_MS;
const CHECK_CACHE_INTERVAL_IN_MS = 15 * 1000; /* 15 sec for now */
export default {
  name: "App",
  data() {
    return {
      cache_ts: Date.now()
    };
  },
  mounted() {
    setInterval(() => {
      this.check_cache();
    }, CHECK_CACHE_INTERVAL_IN_MS);
  },
  methods: {
    check_cache: function() {
      const now = Date.now();
      const cache_age = now - this.cache_ts;
      if (cache_age > RELOAD_CACHE_AFTER_MS) {
        this.update_cache();
      }
    },
    update_cache: function() {
      console.log("Updating the cache...");
      window.location.reload();
    }
  }
};
</script>

<style>
html {
  box-sizing: border-box;
  background-color: white;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.page {
  text-align: left;
}
/*<!-- Buttons on Pages --> */
.page_nav_button {
  position: fixed;
  left: 40%;
  font-size: 1rem;
  font-weight: bold;
  margin: auto;
  color: white;
  bottom: 0.25rem;
  border: 3px solid slategrey;
  padding-top: 30px;
  padding: 10px;
  border-radius: 0.5rem;
  background-color: cornflowerblue;
}
.page_nav_link {
  padding: 1px;
  text-decoration: underline;
  color: black;
}
.page_nav_link:hover,
.page_nav_button:hover {
  background-color: navy;
  color: white;
}
.page > p,
.text_info {
  max-width: 400px;
  align-self: center;
  margin: auto;
  padding-bottom: 1rem;
}
.page > p:last-child {
  margin-bottom: 30px;
}
/**
font-family: 'Archivo Black', sans-serif;
font-family: 'Montserrat', sans-serif;
font-family: 'Roboto', sans-serif;
 */
.page > h1,
h2,
h3,
h4 {
  color: black;
  font-family: "Archivo Black", sans-serif;
}
.page > h1 {
  font-size: 1.3rem;
}
.page > h2,
h3,
h4 {
  font-size: 1.15rem;
  color: #504f54;
}
.page > h3 {
  font-size: 1rem;
}
.page > h4 {
  font-size: 0.8rem;
}
.page {
  max-width: 450px;
  margin: auto;
}

/**
Transition animations */
.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}
.slide-enter {
  transform: translateX(100%);
}
.slide-leave-to {
  transform: translateX(-100%);
}
/** leave some room between paragraphs */
p {
  margin-bottom: 0.4rem;
}
</style>
